import styled, { css } from 'styled-components';

export const OutToTheEdgeOfCardCss = css`
  margin-left: -${({ theme }) => theme.spacing.spacing5};
  margin-right: -${({ theme }) => theme.spacing.spacing5};
`;

export const OutToTheEdgeOfCard = styled.div`
  ${OutToTheEdgeOfCardCss}
`;
